import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=2cc5aace&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc5aace')) {
      api.createRecord('2cc5aace', component.options)
    } else {
      api.reload('2cc5aace', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=2cc5aace&", function () {
      api.rerender('2cc5aace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/user/Users.vue"
export default component.exports